/*
 *
 * TermsAndConditionsDisputlessPopup
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 24-Jun-2025
 */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Skeleton } from '@mui/material'
import MerchantModal from '@nexidigital/merchantmodal'
import Markdown from 'markdown-to-jsx'
import { fetchMarkdown } from 'Utility/fetchMarkdown'
import { getLanguage } from 'Utility/globalMethods'
import formattedMessage, { messages } from './languageModule'
import './TermsAndConditionsDisputlessPopup.scss'

const TermsAndConditionsDisputlessPopup = ({ actions }) => {
  const [markdown, setMarkdown] = React.useState('')
  const intl = useIntl()

  useEffect(() => {
    fetchMarkdown('tec_disputless.md', 'nexi', getLanguage(), (text) => {
      // TODO: replace 'nexi' with the actual bank code if needed
      setMarkdown(text)
    })
  }, [])

  return (
    <MerchantModal
      onClose={() => actions.onClose()}
      primaryAction={() => actions.onClose()}
      closeLabel={intl.formatMessage(messages.ariaLabel)}
      primaryButtonLabel={intl.formatMessage(messages.closeLabel)}
      bigPopup>
      <div className='terms-and-conditions-disputless-popup'>
        {markdown === '' && <Skeleton variant='rounded' sx={{ height: '100%' }} />}
        {markdown && (
          <Markdown
            options={{
              overrides: {
                h1: ({ children, ...props }) => <h2 {...props}>{children}</h2>
              }
            }}>
            {markdown}
          </Markdown>
        )}
        {markdown === undefined && formattedMessage.error}
      </div>
    </MerchantModal>
  )
}

TermsAndConditionsDisputlessPopup.propTypes = {
  actions: PropTypes.shape({
    onClose: PropTypes.func.isRequired
  }).isRequired
}

TermsAndConditionsDisputlessPopup.defaultProps = {
  // Add here some default propTypes values
}

export default TermsAndConditionsDisputlessPopup
